import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getMegaphoneNetworks } from '@account_module/services/megaphone';
import { MEGAPHONE_INTEGRATION_QUERY_KEY } from '@account_module/constants/onBoardingKeys';

export const useMegaphoneNetworks = (organization_id: string | null, token: string | null) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: [MEGAPHONE_INTEGRATION_QUERY_KEY.NETWORKS, organization_id, token],
    queryFn: () => getMegaphoneNetworks({ organization_id, token }),
    enabled: !!organization_id && !!token,
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  const networksIds = useMemo(() => data?.map((network) => network.id), [data]);

  return {
    data: data ? data.map((network) => network) : [],
    networksIds,
    error,
    isLoading,
    refetch,
  };
};
